var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99995 9.78672L5.06245 13.7242C4.94995 13.8367 4.8187 13.893 4.6687 13.893C4.5187 13.893 4.38745 13.8367 4.27495 13.7242C4.16245 13.6117 4.1062 13.4805 4.1062 13.3305C4.1062 13.1805 4.16245 13.0492 4.27495 12.9367L8.21245 8.99922L4.27495 5.06172C4.16245 4.94922 4.1062 4.81797 4.1062 4.66797C4.1062 4.51797 4.16245 4.38672 4.27495 4.27422C4.38745 4.16172 4.5187 4.10547 4.6687 4.10547C4.8187 4.10547 4.94995 4.16172 5.06245 4.27422L8.99995 8.21172L12.9375 4.27422C13.05 4.16172 13.1812 4.10547 13.3312 4.10547C13.4812 4.10547 13.6125 4.16172 13.725 4.27422C13.8375 4.38672 13.8937 4.51797 13.8937 4.66797C13.8937 4.81797 13.8375 4.94922 13.725 5.06172L9.78745 8.99922L13.725 12.9367C13.8375 13.0492 13.8937 13.1805 13.8937 13.3305C13.8937 13.4805 13.8375 13.6117 13.725 13.7242C13.6125 13.8367 13.4812 13.893 13.3312 13.893C13.1812 13.893 13.05 13.8367 12.9375 13.7242L8.99995 9.78672Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmall);
export default __webpack_public_path__ + "static/media/close_small.79c319d9886793adb1ab1b20059196b7.svg";
export { ForwardRef as ReactComponent };